/**
 * Displays an alert message on the web page and hides it after a short duration.
 *
 * @param {string} message - The message to be displayed in the alert.
 */
export const showAlert = function (message, alertTime = 2500) {
  const alertElement = document.getElementById("alert");
  alertElement.textContent = "";
  alertElement.classList.remove("hidden");
  alertElement.textContent = message;
  alertElement.style.pointerEvents = "none";
  // alertElement.style.color = "red";

  alertElement.innerHTML = message.replace(/\n/g, "<br>");
  if (alertTime > 0) {
    setTimeout(function () {
      if (alertElement.parentElement) {
        alertElement.classList.add("hidden");
      }
    }, alertTime);
  }
};

const liveCallDataUnavailableMessage =
  "Live call data is temporarily unavailable. The map is still available. Please try again shortly.";

export const showLiveCallDataUnavailable = function () {
  const alertElement = document.getElementById("alert");
  alertElement.dataset.source = "live-call-data";
  showAlert(liveCallDataUnavailableMessage, 0);
};

export const clearLiveCallDataUnavailable = function () {
  const alertElement = document.getElementById("alert");
  if (alertElement.dataset.source === "live-call-data") {
    alertElement.classList.add("hidden");
    delete alertElement.dataset.source;
  }
};
